import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { Characteristic } from '../model/models'

export class CharacteristicAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.getCharacteristicsForEmpiricalConceptId =
      this.getCharacteristicsForEmpiricalConceptId.bind(this)
  }

  public getCharacteristicsForEmpiricalConceptId(
    empiricalConceptId: number,
  ): Promise<Characteristic[]> {
    const endpoint = `/empirical-concepts/${empiricalConceptId}/characteristics`
    return this.get<Characteristic[]>(endpoint)
      .then((response: AxiosResponse<Characteristic[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public getCharacteristics(): Promise<Characteristic[]> {
    const endpoint = `/characteristics`
    return this.get<Characteristic[]>(endpoint)
      .then((response: AxiosResponse<Characteristic[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const characteristicAPI = new CharacteristicAPI(httpConfig)
